/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ListItemFacility_Node = {
    readonly " $fragmentRefs": FragmentRefs<"ListItemNode_Node" | "TypographyNodeName_Node">;
    readonly " $refType": "ListItemFacility_Node";
};
export type ListItemFacility_Node$data = ListItemFacility_Node;
export type ListItemFacility_Node$key = {
    readonly " $data"?: ListItemFacility_Node$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ListItemFacility_Node">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ListItemFacility_Node",
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "includeAvatar",
          "value": false
        }
      ],
      "kind": "FragmentSpread",
      "name": "ListItemNode_Node"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TypographyNodeName_Node"
        }
      ],
      "type": "Facility",
      "abstractKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
(node as any).hash = '3e71220647a5314953c567461bfc5052';
export default node;
